/* Ingrediens-tjek: klientlaget.
 *
 * ES5, IIFE, ingen imports og ingen build. Sådan er alt andet JS i temaet, og
 * der findes ingen bundler her.
 *
 * ARKITEKTURENS HOVEDREGEL: modellen læser, databasen dømmer. Denne fil sender
 * et foto til /transskriber, som KUN afskriver, og en tekstliste til /analyse,
 * hvor dommen kommer fra vores egen kildebelagte tabel. Der beregnes ikke én
 * vurdering her i browseren. Gør man det, er hele evidensarbejdet spildt.
 *
 * GATEN LIGGER I WORKEREN, ikke her. Denne fil viser kun resuméet indtil
 * /rapport/{id}/frigiv har svaret. Ville vi gate i browseren, kunne enhver læse
 * hele dommen i netværksfanen, og så er det ikke en gate men et gardin.
 *
 * BILLEDET GEMMES ALDRIG. Det læses som base64, sendes én gang, og hverken
 * browseren eller serveren skriver det nogen steder.
 *
 * Fælder der er håndteret:
 * - Sektionen kan genindsættes af Theme Editor via innerHTML, og så kører dette
 *   script ikke igen. Derfor lyttes på shopify:section:load.
 * - PostHog findes først efter Cookiebot-samtykke, så måling er både guardet og
 *   pakket i try/catch. Måling må aldrig kunne vælte værktøjet.
 * - Email og fotodata sendes ALDRIG til PostHog.
 */
(function () {
  'use strict';

  var MAX_BYTES = 3700000; // ~5 MB base64, samme grænse som Workeren håndhæver

  /* Måling. Guard + try/catch, samme mønster som cosmo-guide-embed.js:
     PostHog indlæses slet ikke før Cookiebot-samtykke. */
  function maal(navn, props) {
    try {
      if (!window.posthog || !window.posthog.capture) return;
      var p = props || {};
      p.page_url = location.pathname;
      window.posthog.capture(navn, p);
    } catch (e) {}
  }

  function tekst(el, v) { el.textContent = v; }

  /* Alt brugerdata sættes med textContent, aldrig innerHTML. Et INCI-navn kommer
     fra en fotoaflæsning og er derfor ikke betroet input. */
  function lav(tag, klasse, indhold) {
    var el = document.createElement(tag);
    if (klasse) el.className = klasse;
    if (indhold != null) el.textContent = indhold;
    return el;
  }

  function vis(el, synlig) {
    if (el) el.hidden = !synlig;
  }

  function json(url, krop) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(krop)
    }).then(function (r) {
      return r.json().then(function (d) {
        // Workeren svarer med JSON også på fejl, så statuskoden alene er ikke nok.
        if (d && d.fejl) throw new Error(d.fejl);
        if (!r.ok) throw new Error('Der gik noget galt. Prøv igen.');
        return d;
      });
    });
  }

  function start(rod) {
    if (!rod || rod.dataset.itKlar === '1') return;
    rod.dataset.itKlar = '1';

    var api = rod.dataset.itApi;
    if (!api) return;
    api = api.replace(/\/+$/, '');

    var q = function (navn) { return rod.querySelector('[data-it="' + navn + '"]'); };

    var el = {
      faner: rod.querySelectorAll('[data-it-fane]'),
      panelFoto: q('panel-foto'),
      panelTekst: q('panel-tekst'),
      fil: q('fil'),
      filNavn: q('fil-navn'),
      inci: q('inci'),
      maerke: q('maerke'),
      produkt: q('produkt'),
      send: q('send'),
      arbejder: q('arbejder'),
      arbejderTekst: q('arbejder-tekst'),
      fejl: q('fejl'),
      trinInput: q('trin-input'),
      trinResume: q('trin-resume'),
      resumeTal: q('resume-tal'),
      resumeLinje: q('resume-linje'),
      resumeIngenLinje: q('resume-ingen-linje'),
      problem: q('problem'),
      problemSend: q('problem-send'),
      gate: q('gate'),
      email: q('email'),
      mobil: q('mobil'),
      samtykkeLagring: q('samtykke-lagring'),
      samtykkeMarked: q('samtykke-marked'),
      frigiv: q('frigiv'),
      trinRapport: q('trin-rapport'),
      rapport: q('rapport')
    };

    // kilde: 'tekst' indtil et foto faktisk er blevet læst. Workeren kan ikke
    // selv vide det, fordi /transskriber med vilje intet gemmer der kunne knytte
    // en aflæsning til den analyse der kommer bagefter.
    var tilstand = { id: null, inci: '', problem: '', kilde: 'tekst', klarSendt: false };

    /* Måling der skal overleve at brugeren lukker fanen. Workeren hvidlister
       navnene, så der kan ikke opfindes nye herfra. Fejl ignoreres: et målepunkt
       må aldrig kunne vælte værktøjet. */
    function haendelse(navn) {
      if (!tilstand.id) return;
      try {
        fetch(api + '/haendelse', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: tilstand.id, navn: navn }),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }

    function fejl(besked) {
      if (!el.fejl) return;
      tekst(el.fejl, besked);
      vis(el.fejl, !!besked);
    }

    function arbejder(besked) {
      if (!el.arbejder) return;
      if (el.arbejderTekst && besked) tekst(el.arbejderTekst, besked);
      vis(el.arbejder, !!besked);
    }

    /* ---------- faner: foto eller indsat tekst ---------- */

    function vaelgFane(navn) {
      for (var i = 0; i < el.faner.length; i++) {
        var f = el.faner[i];
        var valgt = f.dataset.itFane === navn;
        f.setAttribute('aria-selected', valgt ? 'true' : 'false');
      }
      vis(el.panelFoto, navn === 'foto');
      vis(el.panelTekst, navn === 'tekst');
    }

    for (var i = 0; i < el.faner.length; i++) {
      el.faner[i].addEventListener('click', function (e) {
        vaelgFane(e.currentTarget.dataset.itFane);
      });
    }

    /* ---------- foto -> tekst ---------- */

    if (el.fil) {
      el.fil.addEventListener('change', function () {
        var f = el.fil.files && el.fil.files[0];
        if (!f) return;
        fejl('');
        if (el.filNavn) tekst(el.filNavn, f.name);

        if (f.size > MAX_BYTES) {
          fejl('Billedet er for stort. Tag et nærbillede af selve ' +
               'ingredienslisten i stedet for hele produktet.');
          return;
        }

        arbejder('Læser ingredienslisten på billedet');
        maal('ingrediens_foto_valgt', { bytes: f.size });

        var laeser = new FileReader();
        laeser.onerror = function () {
          arbejder('');
          fejl('Billedet kunne ikke læses. Prøv et andet, eller indsæt ' +
               'listen som tekst.');
        };
        laeser.onload = function () {
          // dataURL er "data:image/jpeg;base64,AAAA..." og Workeren vil kun have
          // delen efter kommaet.
          var kommaet = String(laeser.result).indexOf(',');
          var base64 = String(laeser.result).slice(kommaet + 1);

          json(api + '/transskriber', { billede: base64, medietype: f.type })
            .then(function (d) {
              arbejder('');
              if (el.inci) el.inci.value = d.inci;
              // Listen stammer nu fra et foto, også selvom den vises i
              // tekstfeltet. Uden dette står hver eneste analyse som indsat
              // tekst, og forholdet mellem de to kan ikke måles.
              tilstand.kilde = 'foto';
              vaelgFane('tekst');
              maal('ingrediens_foto_laest', {
                antal: d.antal, ulaeselige: d.ulaeselige
              });
              if (d.ulaeselige > 0) {
                fejl(d.ulaeselige + ' linjer kunne ikke læses sikkert og er ' +
                     'udeladt. Tjek listen herunder, og ret den hvis der ' +
                     'mangler noget.');
              }
            })
            .catch(function (e) {
              arbejder('');
              fejl(e.message);
              maal('ingrediens_foto_fejl', {});
            });
        };
        laeser.readAsDataURL(f);
      });
    }

    /* ---------- analysen ---------- */

    function analyser(problem, erstatter) {
      var raa = el.inci ? el.inci.value.trim() : '';
      /* Tekst-vejen havde intet startpunkt i tragten: foto-flowet maales af
         foto_valgt/foto_laest, men den der indsaetter listen manuelt, dukkede
         foerst op ved analyse_faerdig. Fundet ved Mortens tracking-gennemgang
         8. august 2026. */
      if (!erstatter) {
        maal('ingrediens_analyse_startet', { kilde: tilstand.kilde || 'tekst' });
      }
      if (raa.length < 20) {
        fejl('Indsæt hele ingredienslisten fra bagsiden af produktet, eller ' +
             'tag et billede af den.');
        return;
      }

      fejl('');
      arbejder('Analyserer ingredienslisten');

      var krop = {
        inci: raa,
        hudproblem: problem || null,
        maerke: el.maerke ? el.maerke.value.trim() || null : null,
        produkt_navn: el.produkt ? el.produkt.value.trim() || null : null,
        kilde: tilstand.kilde
      };
      // Vælger brugeren et hudproblem bagefter, køres analysen igen. erstatter
      // fjerner den forrige, endnu ikke frigivne række, så der ikke ligger to
      // rækker pr. bruger og tæller dobbelt i målingen.
      if (erstatter) krop.erstatter = erstatter;

      json(api + '/analyse', krop)
        .then(function (d) {
          arbejder('');

          if (!d.brugbar) {
            // Motoren kalder feltet note, ikke hvorfor. Med det forkerte navn
            // faldt den præcise forklaring altid tilbage til den generiske.
            fejl(d.input && d.input.note
              ? d.input.note
              : 'Det ser ikke ud som en fuld ingrediensliste. Deklarationen ' +
                'står med lille skrift bag på emballagen og begynder næsten ' +
                'altid med Aqua eller Water.');
            maal('ingrediens_analyse_ubrugbar', {});
            return;
          }

          tilstand.id = d.id;
          tilstand.problem = problem || '';
          visResume(d);
          maal('ingrediens_analyse_faerdig', {
            antal: d.antal,
            hudproblem: problem || 'ikke_valgt',
            linje_fundet: !!d.linje_fundet
          });
        })
        .catch(function (e) {
          arbejder('');
          fejl(e.message);
        });
    }

    if (el.send) {
      el.send.addEventListener('click', function () { analyser(tilstand.problem, null); });
    }

    if (el.problemSend) {
      el.problemSend.addEventListener('click', function () {
        var valgt = el.problem ? el.problem.value : '';
        if (!valgt) return;
        // Hudproblemet er helbredsdata efter GDPR artikel 9. Det spørges derfor
        // EFTER den generelle analyse og er frivilligt: værktøjet svarer også
        // uden det.
        analyser(valgt, tilstand.id);
      });
    }

    /* ---------- resuméet, altid frit ---------- */

    function visResume(d) {
      vis(el.trinResume, true);
      vis(el.gate, true);

      if (el.resumeTal) {
        el.resumeTal.innerHTML = '';
        var tal = [
          ['Ingredienser', d.antal],
          ['Aktive stoffer', d.resume.aktive],
          ['Base', d.resume.base],
          ['Ukendte', d.resume.ukendte]
        ];
        if (d.resume.paa_problemet != null && tilstand.problem) {
          tal.splice(1, 0, ['Arbejder på dit problem', d.resume.paa_problemet]);
        }
        for (var j = 0; j < tal.length; j++) {
          var boks = lav('div');
          boks.appendChild(lav('dt', null, tal[j][0]));
          boks.appendChild(lav('dd', null, String(tal[j][1])));
          el.resumeTal.appendChild(boks);
        }
      }

      /* Vi siger det OGSÅ når vi ikke fandt linjen. Før stod boksen bare tom,
         og så var det umuligt for brugeren at se forskel på "vi kiggede ikke"
         og "vi kunne ikke finde den". Samme princip som "Det kunne vi ikke slå
         op" nede i rapporten, og det er det FAQ'en lover. */
      if (el.resumeLinje) {
        vis(el.resumeLinje, !!d.linje_fundet);
      }
      if (el.resumeIngenLinje) {
        vis(el.resumeIngenLinje, !d.linje_fundet);
      }

      if (el.trinResume && el.trinResume.scrollIntoView) {
        el.trinResume.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      maal('ingrediens_gate_vist', {});
      // Samme punkt til vores egen tabel. PostHog findes først efter
      // Cookiebot-samtykke, så uden dette mangler tragten sit midterste trin
      // for enhver der ikke har sagt ja til statistik-cookies.
      haendelse('gate_vist');
    }

    /* ---------- gaten ---------- */

    function opdaterFrigiv() {
      if (!el.frigiv) return;
      var klar = el.email && el.email.value.indexOf('@') > 0 &&
        el.samtykkeLagring && el.samtykkeLagring.checked &&
        el.samtykkeMarked && el.samtykkeMarked.checked;
      el.frigiv.disabled = !klar;
      // Første gang knappen låser op, siger vi det. Uden det kan en afbrudt
      // kørsel ikke skelnes fra en hvor knappen aldrig blev tilgængelig, og
      // netop det spørgsmål kunne vi ikke besvare om kørslen 30. juli.
      // tilstand.id skal være der, ellers markerer vi punktet som sendt uden at
      // have sendt noget. Autofyld kan udfylde mailen før en analyse findes.
      if (klar && !tilstand.klarSendt && tilstand.id) {
        tilstand.klarSendt = true;
        haendelse('gate_klar');
      }
    }

    [el.email, el.samtykkeLagring, el.samtykkeMarked].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', opdaterFrigiv);
      f.addEventListener('change', opdaterFrigiv);
    });
    opdaterFrigiv();

    if (el.frigiv) {
      el.frigiv.addEventListener('click', function () {
        if (!tilstand.id) return;
        fejl('');
        arbejder('Henter din analyse');

        // De to samtykker sendes som de FAKTISK står, ikke som faste true.
        // Knappen er ganske vist låst indtil begge er krydset af, men rækken i
        // databasen er vores dokumentation for samtykket, og den må afspejle
        // felterne frem for en konstant. Workeren afviser i forvejen false.
        json(api + '/rapport/' + tilstand.id + '/frigiv', {
          email: el.email.value.trim(),
          mobil: el.mobil && el.mobil.value.trim() ? el.mobil.value.trim() : null,
          samtykke_lagring: !!(el.samtykkeLagring && el.samtykkeLagring.checked),
          samtykke_markedsfoering: !!(el.samtykkeMarked && el.samtykkeMarked.checked)
        })
          .then(function (d) {
            arbejder('');
            vis(el.gate, false);
            visRapport(d.rapport);
            // Emailen sendes ALDRIG til PostHog. Kun at gaten blev passeret.
            maal('ingrediens_email_afgivet', {
              hudproblem: tilstand.problem || 'ikke_valgt'
            });
          })
          .catch(function (e) {
            arbejder('');
            fejl(e.message);
          });
      });
    }

    /* ---------- rapporten ---------- */

    function evidensMaerkat(post) {
      // Har stoffet ingen selvstændig evidensvurdering, er det med i listen
      // fordi hele dens funktionsgruppe virker på problemet, fx en fugtgiver
      // mod tørhed. Den forskel SKAL være synlig: uden den læser glycerin som
      // lige så godt dokumenteret som panthenol.
      if (!post.evidens) {
        /* Har gruppen en gruppeside, er maerkatet et link til den. Stien
           kommer fra Workeren (post.gruppe_side), samme kilde som mailen. */
        if (post.gruppe_side) {
          var m = lav('a', 'it-maerkat it-maerkat--gruppe', post.gruppe);
          m.href = post.gruppe_side;
          m.target = '_blank';
          m.rel = 'noopener';
          return m;
        }
        return lav('span', 'it-maerkat it-maerkat--gruppe', post.gruppe);
      }
      var navne = {
        staerk: 'Stærk evidens',
        moderat: 'Moderat evidens',
        svag: 'Svag evidens',
        ingen: 'Ingen dokumenteret effekt'
      };
      return lav('span', 'it-maerkat it-maerkat--' + post.evidens,
                 navne[post.evidens] || post.evidens);
    }

    /* Kilden står VED det enkelte udsagn og ikke samlet i bunden. Uden
       lægegodkendelse er kilderne det eneste der bærer troværdigheden.

       post.kilder er et OBJEKT med en liste pr. påstand: niveau, virker_paa,
       virksom_fra, kan_ikke. Ikke en flad liste. Formen var forkert i det første
       udkast her, og fejlen var tavs: kilderne forsvandt uden en fejlmeddelelse.
       Krydstjekket i worker/test/krydstjek.mjs måler nu formen, netop derfor. */
    function kildeLinje(kilder, forled) {
      if (!kilder || !kilder.length) return null;
      var p = lav('p', 'it-kilde');
      p.appendChild(document.createTextNode(forled + ': '));
      for (var k = 0; k < kilder.length; k++) {
        if (k > 0) p.appendChild(document.createTextNode(', '));
        if (kilder[k].url) {
          var a = lav('a', null, kilder[k].titel || kilder[k].url);
          a.href = kilder[k].url;
          a.target = '_blank';
          a.rel = 'noopener nofollow';
          p.appendChild(a);
        } else {
          p.appendChild(document.createTextNode(kilder[k].titel || ''));
        }
      }
      return p;
    }

    function ingrediensPost(post) {
      var li = lav('li', post.over_1pct ? null : 'it-under-linjen');
      li.appendChild(lav('span', 'it-plads', String(post.plads)));

      var midt = lav('div');
      /* Har stoffet et faktablad, er navnet et link til det. Stien kommer fra
         Workeren (post.side), som har den fra samme kobling som migreringen,
         saa SODIUM HYALURONATE lander paa hyaluronsyre-siden. Uden post.side
         (stof uden record, eller en Worker fra foer 8. august 2026) er navnet
         en span som hidtil, saa rapporten aldrig kan faa et doedt link. */
      if (post.side) {
        var navnLink = lav('a', 'it-navn', post.inci);
        navnLink.href = post.side;
        navnLink.target = '_blank';
        navnLink.rel = 'noopener';
        midt.appendChild(navnLink);
      } else {
        midt.appendChild(lav('span', 'it-navn', post.inci));
      }

      /* Stoffer der taeller med via deres FUNKTIONSGRUPPE (fx glycerin mod
         toerhed) har ingen egen evidensvurdering, og det skal siges, ellers
         ligner de en glemt dom. De staar OGSAA under basen, med vilje. */
      var gruppeForklaring = {
        'fugtgiver': 'Tæller med fordi fugtgivere som gruppe binder vand i huden. Stoffet har ikke sin egen evidensvurdering, og derfor står det også under basen nedenfor.',
        'emolliens': 'Tæller med fordi emollienser som gruppe blødgør huden og mindsker fugttab. Stoffet har ikke sin egen evidensvurdering, og derfor står det også under basen nedenfor.'
      };
      if (!post.evidens && gruppeForklaring[post.gruppe]) {
        midt.appendChild(lav('p', 'it-detalje', gruppeForklaring[post.gruppe]));
      }
      /* Laegmandslinjen foerst: hvad goer stoffet, sagt som paa faktabladet.
         'indgaar i ceramidkompleks' kunne Morten ikke bruge til noget,
         8. august 2026. Etiketten paa dosis-linjen matcher faktabladets
         afsnit 'Hvor meget der skal til', for vaerdien er ikke altid et tal. */
      if (post.virkning_kort) {
        midt.appendChild(lav('p', 'it-detalje',
          'Sådan virker det: ' + post.virkning_kort));
      }
      if (post.virksom_fra) {
        midt.appendChild(lav('p', 'it-detalje',
          'Hvor meget der skal til: ' + post.virksom_fra));
      }
      midt.appendChild(lav('p', 'it-detalje', post.over_1pct
        ? 'Står over 1 %-linjen'
        : 'Står under 1 %-linjen, altså under 1 %'));

      var kilder = post.kilder || {};
      var linjer = [
        kildeLinje(kilder.niveau, 'Kilde til evidensniveau'),
        kildeLinje(kilder.virksom_fra, 'Kilde til koncentration')
      ];
      for (var n = 0; n < linjer.length; n++) {
        if (linjer[n]) midt.appendChild(linjer[n]);
      }

      li.appendChild(midt);
      li.appendChild(evidensMaerkat(post));
      return li;
    }

    function afsnit(overskrift, indledning) {
      var d = lav('div');
      d.appendChild(lav('h3', null, overskrift));
      if (indledning) d.appendChild(lav('p', null, indledning));
      return d;
    }

    function visRapport(r) {
      if (!el.rapport) return;
      /* Sammenbindingen til biblioteket skal kunne maales: hvert klik fra
         rapporten til et faktablad eller en gruppeside sender ét event med
         maalet. Delegeret listener, saettes kun én gang. */
      if (!el.rapport.__cosmoLinkMaal) {
        el.rapport.__cosmoLinkMaal = true;
        el.rapport.addEventListener('click', function (e) {
          var a = e.target && e.target.closest ? e.target.closest('a[href^="/blogs/ingredienser"]') : null;
          if (a) {
            maal('ingrediens_rapport_link_klik', {
              maal_side: a.getAttribute('href'),
              link_tekst: (a.textContent || '').trim().slice(0, 60)
            });
          }
        });
      }
      el.rapport.innerHTML = '';
      vis(el.trinRapport, true);

      /* 1 %-linjen. Det er værktøjets kerne, så den forklares hver gang og
         ikke kun i FAQ'en. */
      if (r.linje && r.linje.fundet) {
        var linje = lav('div', 'it-linje');
        var s = lav('strong', null, '1 %-linjen ligger ved plads ' +
          r.linje.plads + ', ' + r.linje.markoer + '.');
        linje.appendChild(s);
        linje.appendChild(lav('p', null,
          'En ingrediensliste er sorteret efter mængde ned til 1 %. Derunder er ' +
          'rækkefølgen tilfældig. Alt fra plads ' + r.linje.plads + ' og ned ' +
          'udgør derfor under 1 % af produktet hver.'));
        if (r.linje.hvorfor) linje.appendChild(lav('p', 'it-detalje', r.linje.hvorfor));
        if (r.linje.sikkerhed === 'lav') {
          linje.appendChild(lav('p', 'it-detalje',
            'Bemærk: linjen er usikker på netop denne liste, så tallene skal ' +
            'læses med forbehold.'));
        }
        el.rapport.appendChild(linje);
      } else {
        var ingen = lav('div', 'it-linje');
        ingen.appendChild(lav('strong', null,
          'Vi kunne ikke finde 1 %-linjen på din liste.'));
        ingen.appendChild(lav('p', null,
          'Vi finder den ved et markørstof, altså et stof der næsten altid ' +
          'bruges i under 1 %. Er der ikke et entydigt et af slagsen på listen, ' +
          'siger vi det frem for at gætte. Resten af analysen gælder stadig, ' +
          'men vi kan ikke sige om et aktivstof ligger over eller under grænsen.'));
        el.rapport.appendChild(ingen);
      }

      var paa = r.arbejder_paa_problemet || [];
      if (tilstand.problem) {
        var a1 = afsnit(
          paa.length
            ? 'Det her arbejder på dit problem'
            : 'Ingen af ingredienserne arbejder på dit problem',
          paa.length
            ? null
            : 'Produktet kan godt gøre noget for din hud, men ikke noget der ' +
              'er dokumenteret mod netop det du valgte.');
        if (paa.length) {
          var ul = lav('ul', 'it-liste');
          for (var i2 = 0; i2 < paa.length; i2++) ul.appendChild(ingrediensPost(paa[i2]));
          a1.appendChild(ul);
        }
        el.rapport.appendChild(a1);
      }

      var andre = r.andre_aktive || [];
      if (andre.length) {
        var a2 = afsnit('Andre aktive stoffer i produktet',
          tilstand.problem
            ? 'De gør noget, men ikke mod det du valgte.'
            : null);
        var ul2 = lav('ul', 'it-liste');
        for (var i3 = 0; i3 < andre.length; i3++) ul2.appendChild(ingrediensPost(andre[i3]));
        a2.appendChild(ul2);
        el.rapport.appendChild(a2);
      }

      if (r.mangler_helt && r.mangler_helt.length) {
        var a3 = afsnit('Det mangler produktet helt',
          'Stoffer med stærk eller moderat dokumenteret effekt på det du valgte, ' +
          'som ikke står på listen:');
        a3.appendChild(lav('p', null, r.mangler_helt.join(', ')));
        el.rapport.appendChild(a3);
      }

      if (r.duftallergener && r.duftallergener.length) {
        var a4 = afsnit('Mærkningspligtige duftallergener',
          'EU kræver at disse står på etiketten, fordi de er den hyppigste ' +
          'grund til at nogen reagerer på et produkt. De er ikke farlige for ' +
          'de fleste.');
        a4.appendChild(lav('p', null, r.duftallergener.join(', ')));
        el.rapport.appendChild(a4);
      }

      var base = r.base || [];
      if (base.length) {
        var a5 = afsnit('Resten er base: ' + base.length + ' ingredienser',
          'Vand, olier, emulgatorer, konservering og fortykningsmidler. De ' +
          'får produktet til at fungere og holde, men de behandler ikke noget.');
        /* Stoffer hvis gruppe har en gruppeside, linker derhen: det er
           praecis de stoffer der ellers bare er en remse af kemi-navne. */
        var pBase = lav('p', 'it-detalje');
        for (var i4 = 0; i4 < base.length; i4++) {
          if (i4 > 0) pBase.appendChild(document.createTextNode(', '));
          if (base[i4].side || base[i4].gruppe_side) {
            var ab = lav('a', null, base[i4].inci);
            ab.href = base[i4].side || base[i4].gruppe_side;
            ab.target = '_blank';
            ab.rel = 'noopener';
            pBase.appendChild(ab);
          } else {
            pBase.appendChild(document.createTextNode(base[i4].inci));
          }
        }
        a5.appendChild(pBase);
        el.rapport.appendChild(a5);
      }

      if (r.ukendte && r.ukendte.length) {
        var uk = [];
        for (var i5 = 0; i5 < r.ukendte.length; i5++) uk.push(r.ukendte[i5].inci);
        var a6 = afsnit('Det kunne vi ikke slå op',
          'Vi siger det frem for at gætte. Er der en tastefejl i listen, så ' +
          'ret den og kør analysen igen.');
        a6.appendChild(lav('p', 'it-detalje', uk.join(', ')));
        el.rapport.appendChild(a6);
      }

      /* Hvad creme beviseligt ikke kan. Det er den halvdel der gør værktøjet
         til vores, og den peger mod klinikken uden at være en reklame.
         Dommen falder ALDRIG på produktet eller mærket, kun på hvad de enkelte
         stoffer er dokumenteret for. Markedsføringsloven § 21. */
      var kanIkke = [];
      var setTekster = [];
      var alle = paa.concat(andre);
      for (var i6 = 0; i6 < alle.length; i6++) {
        var t = alle[i6].kan_ikke;
        if (t && setTekster.indexOf(t) === -1) {
          setTekster.push(t);
          kanIkke.push({
            tekst: t,
            inci: alle[i6].inci,
            kilder: alle[i6].kilder ? alle[i6].kilder.kan_ikke : null
          });
        }
      }
      if (kanIkke.length) {
        var boks = lav('div', 'it-kanikke');
        boks.appendChild(lav('h3', null, 'Det kan en creme ikke klare'));
        var ul3 = lav('ul');
        for (var i7 = 0; i7 < kanIkke.length; i7++) {
          var li3 = lav('li', null, kanIkke[i7].inci + ': ' + kanIkke[i7].tekst);
          // Også her står kilden ved udsagnet. "Det kan creme ikke" er den
          // påstand der peger mod klinikken, og derfor den der skal kunne
          // efterprøves.
          var kl = kildeLinje(kanIkke[i7].kilder, 'Kilde');
          if (kl) li3.appendChild(kl);
          ul3.appendChild(li3);
        }
        boks.appendChild(ul3);
        el.rapport.appendChild(boks);
      }

      if (el.trinRapport.scrollIntoView) {
        el.trinRapport.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      maal('ingrediens_rapport_vist', {
        hudproblem: tilstand.problem || 'ikke_valgt',
        antal_paa_problemet: paa.length
      });
    }

    vaelgFane('foto');
  }

  function startAlle(rod) {
    var noder = (rod || document).querySelectorAll('[data-it-rod]');
    for (var i = 0; i < noder.length; i++) start(noder[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { startAlle(); });
  } else {
    startAlle();
  }

  /* Theme Editor genindsætter sektionens HTML via innerHTML når en indstilling
     ændres, og scripts i den kører ikke igen. Uden dette er værktøjet dødt for
     redaktøren så snart en tekst rettes. */
  document.addEventListener('shopify:section:load', function (e) {
    startAlle(e.target);
  });
})();
